{
  "OK_BUTTON": "Ok",
  "YES_BUTTON": "Yes",
  "NO_BUTTON": "No",

  "BAIL_OUT_LINK": "Submit the loan without BOLT",
  "BAIL_OUT_TITLE": "Do you want to submit the loan without BOLT?",
  "BAIL_OUT_QUESTION": "Your loan will be reviewed within standard turn times and will no longer be eligible for BOLT.",

  "POST_TRIGGER_ALL_RULES_ERROR_MESSAGE": "There was an issue refreshing",
  "GET_BOLT_STATUS_ERROR_MESSAGE": "There was an issue identifying this loan",
  "SUBMIT_TO_SETUP_ERROR_MESSAGE": "There was an issue saving this loan",
  "GET_NAVIGATION_DETAILS_ERROR_MESSAGE": "There was an issue retrieving navigation items",
  "SUBMIT_LOAN_TO_SET_UP_ERROR_MESSAGE": "There was an issue submitting the loan",
  "GET_UNDERWRITER_VERIFICATION_STATUS_ERROR": "There was an issue retrieving underwriter verifications",
  "SAVE_UNDERWRITER_RULE_VERIFICATION_ERROR_MESSAGE": "There was an issue saving this verification",
  "GET_LOAN_SUMMARY_ERROR_MESSAGE": "There was an issue retrieving loan summary data",
  "DEFAULT_OOPS_HEADER": "OOPS! An error occurred.",
  "DEFAULT_OOPS_DESCRIPTION": "Please try again later or contact your AE."
}
